import { Box, Typography, useTheme } from '@mui/material'

const UserProfileInfoPage = ({ userInfo }) => {
  const theme = useTheme()
  const dc = theme.palette.designTokens

  const cardSx = {
    background: dc.card,
    border: `1px solid ${dc.cardBorder}`,
    borderRadius: '20px',
    backdropFilter: 'none',
    p: '32px 40px 40px',
  }

  const InfoField = ({ label, icon, value, full }) => (
    <Box sx={full ? { gridColumn: '1 / -1' } : undefined}>
      <Typography
        component="span"
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: dc.label,
          mb: 1,
          display: 'block',
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          background: dc.field,
          border: `1px solid ${dc.fieldBorder}`,
          borderRadius: '10px',
          px: '14px',
          py: '11px',
          minHeight: 46,
        }}
      >
        <Box component="span" sx={{ fontSize: 17, lineHeight: 1 }}>
          {icon}
        </Box>
        <Typography
          sx={{
            fontSize: 15,
            color: value ? dc.value : dc.muted,
            wordBreak: 'break-word',
          }}
        >
          {value || '—'}
        </Typography>
      </Box>
    </Box>
  )

  return (
    <Box sx={cardSx}>
      <Typography sx={{ fontSize: 20, fontWeight: 800, color: '#f1f5f9', mb: '28px' }}>
        Kullanıcı Bilgileri
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: '20px 32px',
        }}
      >
        <InfoField label="ID" icon="🚩" value={userInfo.id} />
        <InfoField label="Ad" icon="👤" value={userInfo.name} />
        <InfoField label="E-posta" icon="✉️" value={userInfo.email} />
        <InfoField label="Şifre" icon="🔒" value="************" />
        <InfoField
          label="Yetki"
          icon="💼"
          value={
            userInfo.role
              ? userInfo.role === 'admin'
                ? 'Yönetici'
                : 'Kullanıcı'
              : ''
          }
        />
        <InfoField
          label="E-posta Doğrulaması"
          icon={userInfo.isEmailVerified ? '✅' : '❌'}
          value={userInfo.isEmailVerified ? 'Onaylı' : 'Onaylı Değil'}
        />
        <InfoField
          label="Oluşturma Tarihi"
          icon="📅"
          value={
            userInfo.created_at
              ? String(userInfo.created_at).split('T')[0]
              : ''
          }
        />
        <InfoField
          label="Güncelleme Tarihi"
          icon="🕐"
          value={
            userInfo.updated_at
              ? String(userInfo.updated_at).split('T')[0]
              : ''
          }
        />
      </Box>
    </Box>
  )
}

export default UserProfileInfoPage
